import MockAdapter from "axios-mock-adapter/types";
import { URL_GET_RECORD_STAMP_MODIFICATIONS } from "@/requests/recordStamp";
import GetRecordStampResponse from "@/models/api/recordStamp/GetRecordStampResponse";

export const recordStampMock = (mock: MockAdapter): void => {
  mock.onGet(URL_GET_RECORD_STAMP_MODIFICATIONS).reply(200, {
    createdAt: "2021-01-22 15:12:57",
    userName: "dwrobel",
    description: "Dej nam spokój",
    recordStampModifications: [
      {
        modifyAt: "2021-01-22 15:13:25",
        userName: "dwrobel",
        description: "Przedrukowanie dokumentu numer: 13/01/2021/RZE",
      },
      {
        modifyAt: "2021-01-22 15:13:02",
        userName: "dwrobel",
        description: "Przedrukowanie dokumentu numer: 13/01/2021/RZE",
      },
    ],
  } as GetRecordStampResponse);
};
